import { render, staticRenderFns } from "./picture-block.vue?vue&type=template&id=d8e0601a&scoped=true"
import script from "./picture-block.vue?vue&type=script&lang=js"
export * from "./picture-block.vue?vue&type=script&lang=js"
import style0 from "./picture-block.vue?vue&type=style&index=0&id=d8e0601a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e0601a",
  null
  
)

export default component.exports